export default __webpack_public_path__ + "static/media/chessset.4c6d454a.png";